<script lang="ts" setup>
import { useOnline } from '@vueuse/core'

import { useToasts } from '~/composables/useToasts'
import { META } from '~/environment-variables/meta.const'

const online = useOnline()

const { showToast, closeToast } = useToasts()

watchEffect(() => {
  if (!online.value) {
    showToast({
      message: 'Unable to connect to the server. Please check your internet connection.',
      status: 'ERROR',
    })
  } else {
    closeToast()
  }
})

useHead({
  templateParams: {
    separator: META.titleSeparator,
    siteName: META.siteName,
  },
  titleTemplate: '%s %separator %siteName',
})

useSeoMeta(getMeta())

const { initializeModal } = useMaintenanceModal()

onMounted(() => {
  initializeModal()
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>